var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.quiz.questions),function(question,idx){return _c('Radiogroup',{attrs:{"question":question,"feedback":_vm.answer[question.id],"is_submitted":true}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }